export default __webpack_public_path__ + "static/media/homevilla5.6a0e8e3c.jpg";